__turbopack_context__.v({
  "heroButtons": "gFQvhW_heroButtons",
  "heroCard": "gFQvhW_heroCard",
  "heroContent": "gFQvhW_heroContent",
  "heroDescription": "gFQvhW_heroDescription",
  "heroTitle": "gFQvhW_heroTitle",
});
